export abstract class WebSocketsMessage<T> {
  messageType: string;
  messageBody: T | undefined;

  protected constructor(messageBody: T | undefined, messageType: string) {
    this.messageBody = messageBody;
    this.messageType = messageType;
  }

  isAssignableFrom(message: WebSocketsMessage<any>): message is WebSocketsMessage<T> {
    return message.messageType === this.messageType;
  }
}

export enum WsMessageType {
  NotificationWSMessage = 'NotificationWSMessage',
  ParticipantMessagesWSMessage = 'ParticipantMessagesWSMessage',
  EventWSMessage = 'EventWSMessage',
  EventLogWSMessage = 'EventLogWSMessage',
  ChallengeStatsWSMessage = 'ChallengeStatsWSMessage',
  TeamChatWSMessage = 'TeamChatWSMessage',
  SupportChatWSMessage = 'SupportChatWSMessage',
  SupportChatUpdateWSMessage = 'SupportChatUpdateWSMessage',
  EventIncidentWSMessage = 'EventIncidentWSMessage',
  TeamParticipantModelWSMessage = 'TeamParticipantModelWSMessage',
  CampaignAttemptWSMessage = 'CampaignAttemptWSMessage',
  TeamChallengeAnswerWSMessage = 'TeamChallengeAnswerWSMessage',
  LabAvailabilityWSMessage = 'LabAvailabilityWSMessage',
  // Authoritative 'a team's lab for this challenge is now assigned/ready' signal, keyed by
  // challengeId. Arrives after LabAvailabilityWSMessage, once the lab is actually provisioned.
  LabAssignmentWSMessage = 'LabAssignmentWSMessage',
  EventAnnouncementWSMessage = 'EventAnnouncementWSMessage',
  LeaderboardWSMessage = 'LeaderboardWSMessage',
  // Value matches backend contract — intentionally differs from other enum values
  ChallengeRecommendationWSMessage = 'CHALLENGE_RECOMMENDATIONCompleteWSMessage',
}
export interface AsyncResultMessageBody {
  jobId: string;
  s3Url: string;
}
